import React from "react";
import * as ReactDOM from "react-dom";
import SimpleBar from "simplebar-react";

import "./customScroller.scss";

/**
 * Component for a scrolling area with a custom scrollbar appearance.
 */
export class CustomScroller extends React.Component {
  private scrollElement: Element;

  private onWheel = (e: WheelEvent) => {
    const { overflow } = window.getComputedStyle(this.scrollElement);

    // When the scrolling element is only in the x-direction, remap vertical mousewheel to horizontal
    // simplebar library sets overflow: scroll hidden; in this case.
    // N.B. don't do anything when scrolling is on both axes
    const isOnlyHorizontalScroll = /^\s*scroll\s*hidden\s*/.test(overflow);
    if (isOnlyHorizontalScroll) {
      if (e.deltaX >= 1 || e.deltaX <= -1) {
        // Ignore actual sidescrolling
        return;
      }

      // Improved experience in diff browsers - https://embed.plnkr.co/plunk/skVoXt
      const delta = Math.max(-1, Math.min(1, e.deltaY || -e.detail)) * 60;

      // Map vertical mousewheelin' to horizontal
      this.scrollElement.scrollBy({ left: delta });

      e.preventDefault();
    }
  }

  public componentDidMount() {
    // Grab the native scrolling element and attach scroll handlers - SimpleBar component doesn't support refs
    const element = ReactDOM.findDOMNode(this) as Element;
    this.scrollElement = element.getElementsByClassName("simplebar-content")[0];
    this.scrollElement.addEventListener("wheel", this.onWheel);
  }

  public componentWillUnmount() {
    if (this.scrollElement) {
      this.scrollElement.removeEventListener("wheel", this.onWheel);
    }
  }

  public render() {
    return (
      <SimpleBar>
        {this.props.children}
      </SimpleBar>
    );
  }
}
